// Objects with identity and an imperative API of their own: the board, the engine worker and the
// listener attached to it.
//
// They must never enter the store. They are not serializable, comparing them with === says nothing
// useful, and structuredClone throws on them — which is what `store.get()` with no key does, so a
// single Worker in the state was enough to break a full read of it.
//
// The rule, greppable: if it does not survive JSON.stringify, it lives here.

import type { Api as ChessgroundApi } from "#vendor/chessground/chessground.min.js";
import type { BoardSession } from "../services/boardSession.ts";

export const live: {
    /** The board of the study, while legacy modules still reach for it by this name. */
    ground: ChessgroundApi | null;
    /** Every board on the page, by the name it was made with. */
    boards: Map<string, BoardSession>;
    engineWorker: Worker | null;
    engineReady: Promise<unknown> | null;
} = {
    ground: null,
    boards: new Map(),
    engineWorker: null,
    engineReady: null,
};

// Exposed like the store is, for the browser console and for the end-to-end walk, which has to
// reach the board to play a move.
window.__live = live;
